module.exports = __webpack_public_path__ + "static/video-99b808c306cfec55d73cd4b84f8ac5b2.mp4";